// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.index-module__custom-layout__FUpHz {
  display: flex !important;
  flex-direction: row !important;
  min-width: 100vw !important;
}
.index-module__footer-container__V2org {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.index-module__footer-text__cQHDW {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 2rem;
}
@media (max-width: 577px) {
  .index-module__footer-container__V2org {
    display: flex;
    flex-direction: column;
    gap: 7px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/App/MainApp/index.module.less"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;AACX;AACA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;AACF","sourcesContent":[".custom-layout {\n  display: flex !important;\n  flex-direction: row !important;\n  min-width: 100vw !important;\n}\n.footer-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.footer-text {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 2rem;\n}\n@media (max-width: 577px) {\n  .footer-container {\n    display: flex;\n    flex-direction: column;\n    gap: 7px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"custom-layout": `index-module__custom-layout__FUpHz`,
	"footer-container": `index-module__footer-container__V2org`,
	"footer-text": `index-module__footer-text__cQHDW`
};
export default ___CSS_LOADER_EXPORT___;
